
import { Route } from "react-router-dom";

// Import legal pages
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import CookiePolicy from "@/pages/CookiePolicy";
import Disclaimer from "@/pages/Disclaimer";
import AccessibilityStatement from "@/pages/AccessibilityStatement";
import Sitemap from "@/pages/Sitemap";
import SitemapXML from "@/pages/SitemapXML";

export const legalRoutes = [
  <Route key="privacy" path="/privacy-policy" element={<PrivacyPolicy />} />,
  <Route key="terms" path="/terms-conditions" element={<TermsConditions />} />,
  <Route key="cookie" path="/cookie-policy" element={<CookiePolicy />} />,
  <Route key="disclaimer" path="/disclaimer" element={<Disclaimer />} />,
  <Route key="accessibility" path="/accessibility-statement" element={<AccessibilityStatement />} />,
  <Route key="sitemap" path="/sitemap" element={<Sitemap />} />,
  <Route key="sitemap-xml" path="/sitemap.xml" element={<SitemapXML />} />
];
